import { useQuery } from '@tanstack/react-query'
import { getDocumentName } from '../api/word/office-service'

export function useDocumentName(enabled: boolean = true) {
  return useQuery({
    queryKey: ['DocumentName'],
    queryFn: getDocumentName,
    staleTime: 5000, // same as document structure, could consider refetchInterval in the future
    enabled,
  })
}
